import React, { useContext, VFC } from 'react'
import styled from 'styled-components'

import { Title, TitleWrapper } from '@Components/CMS/Title'
import { Loading } from '@Components/Modal/Loading'
import { ShippingIntro } from '@Components/Shipping/ShippingInfoModal/Intro'
import { ShippingOptions } from '@Components/Shipping/ShippingInfoModal/Options'
import { ShippingPolicy } from '@Components/Shipping/ShippingInfoModal/Policy'
import { ShippingToCountry } from '@Components/Shipping/ShippingInfoModal/ToCountry'
import useShippingLabels from '@Components/Shipping/useShippingLabels'
import { MetadataContext } from '@Globals/Metadata'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'
import { UserContext } from '@Globals/User'

export const ShippingInfoWrapper = styled.div`
  font-size: .875rem;
  ${up('phablet')} {
    font-size: inherit;
  }

  ${TitleWrapper} {
    h3 {
      text-align: center !important;
      font-size: 15px !important;
      margin-bottom: 15px !important;
      margin-top: 0 !important;
    }
  }
`

interface ShippingInfoProps {
  load: boolean
}

export const ShippingInfo: VFC<ShippingInfoProps> = ({ load }) => {
  const { store } = useContext(MetadataContext)
  const { t } = useTranslation()
  const { userData } = useContext(UserContext)
  const { data: shippingOptions, error, isValidating } = useShippingLabels({ load })
  const isLoading = (!store || !userData || isValidating) && !error

  if (isLoading) { return <Loading /> }

  return (
    <ShippingInfoWrapper>
      <Title title={t('header:SHIPPING_OPTIONS')} type="h3" />
      <ShippingToCountry />
      <ShippingIntro />
      <ShippingOptions options={shippingOptions || []} />
      <ShippingPolicy />
    </ShippingInfoWrapper>
  )
}
